import {EntityCapsule, EntityCapsuleProps} from "../entity/capsule.tsx";
import {iconForEntityType} from "../fa.tsx";

export type TruckModelCapsuleProps = EntityCapsuleProps;

export function TruckModelCapsule(props: TruckModelCapsuleProps) {
    const {entity, ...rest} = props;
    if (!!entity && !entity.icon) {
        entity.icon = iconForEntityType("truckModel");
    }
    return <EntityCapsule entity={entity} {...rest}/>
}
